import '~style/blocks/carousel/_services-slider.scss';

[...document.querySelectorAll('.services-slider')].map(el => {

    const startDelay = parseInt(el.getAttribute('data-delay-start'));

   setupServicesSlider(el);

   window.addEventListener('resize', () => setupServicesSlider(el));

    window.addEventListener('scroll', (e) => {
        if (!(window.innerWidth >= 1024)) {
            return;
        }

        const scrollAmount = (el.getBoundingClientRect().y * -1 / 2) - startDelay;
        
        if (scrollAmount > 0) {
            el.querySelector('.services-slider__inner').scroll(scrollAmount, 0);

            let slidesWidth = el.querySelector('.services-slider__slides').clientWidth;
            const innerWidth = el.querySelector('.services-slider__inner').scrollWidth;
            const offsetWidth = el.querySelector('.services-slider__inner').clientWidth;
            const slidesScroll = el.querySelector('.services-slider__inner').scrollLeft;

            const slidesComputed = getComputedStyle(el.querySelector('.services-slider__slides'));

            slidesWidth = slidesWidth - parseFloat(slidesComputed.paddingRight) - 100 // There's an 80 margin on the elements in the slider, plus the dot itself is 20px;

            const scrollMax = innerWidth - offsetWidth

            let percentageScrolled = (slidesScroll / scrollMax); 
            percentageScrolled = percentageScrolled > 1 ? 1 : percentageScrolled;


            const indicatorTransform = (slidesWidth) * percentageScrolled;

            el.querySelector('.services-slider__indicator-inner').style.transform = `translate(${indicatorTransform}px,0)`


        } else {
            el.querySelector('.services-slider__indicator-inner').style.transform = `translate(0,0)`
        }
    });
})  

function setupServicesSlider(el) {
    const endDelay = parseInt(el.getAttribute('data-delay-end'));

    if (window.innerWidth >= 1024) {
        let scrollWidth = el.querySelector('.services-slider__content').scrollWidth;

        if (window.innerWidth > 1920) {
            scrollWidth = scrollWidth * 0.5;
        }
        else if (window.innerWidth > 1366) {
            scrollWidth = scrollWidth * 0.75;
        } else {
            scrollWidth = scrollWidth * 1.0;
        }


        el.style.height = (scrollWidth + endDelay) + 'px';
    } else {
        el.style.height = null;
    }
}